export default "__VITE_ASSET__IpRLbMei__"